import React from "react";
import { Button, Icon } from "antd";
import Spacer from "../Spacer";
import styles from "./index.module.scss";
import useDeviceType from "../../../../Utils/useDeviceType";

interface FooterProps {
    listLength: number;
    activeIndex: number;
    setActiveIndex: (index: number) => void;
}

export default function Footer({
    listLength,
    activeIndex,
    setActiveIndex
}: FooterProps) {
    const { isPC, isMobile } = useDeviceType();

    return (
        <div className={styles.root}>
            {activeIndex > 0 && (
                <Button
                    className={styles.btnPrev}
                    onClick={() => {
                        setActiveIndex(activeIndex - 1);
                    }}>
                    <Icon type="caret-left" /> 上一个
                </Button>
            )}
            {isPC && <Spacer />}

            {activeIndex < listLength - 1 && (
                <Button
                    className={styles.btnNext}
                    onClick={() => {
                        setActiveIndex(activeIndex + 1);
                    }}>
                    下一个 <Icon type="caret-right" />
                </Button>
            )}
        </div>
    );
}
